import React from "react";
import {
  Card,
  Flex,
  Heading,
  Text,
  Divider,
  Button,
} from "@aws-amplify/ui-react";

import "rsuite/Carousel/styles/index.css";
import "rsuite/Badge/styles/index.css";
import { useFoodJournalLatestQuery } from "../api/foodJournal/useFoodJournalQuery";
import { useFoodJournalDeleteMutation } from "../api/foodJournal/useFoodJournalMutation";
import { useNavigate } from "react-router-dom";
import { RiPencilFill } from "react-icons/ri";
import { FiTrash } from "react-icons/fi";
import { useUserQuery } from "../../common/useUserQuery";
export default function FoodJournalsContainer() {
  const { data: userQueryData } = useUserQuery();
  const navigate = useNavigate();
  const { data, isLoading, error } = useFoodJournalLatestQuery(
    userQueryData?.patientUserId
  );

  const deleteFoodJournal = useFoodJournalDeleteMutation();

  if (isLoading) return "Loading...";

  if (error) return "Error loading Food Journal, check console for output";

  return (
    <Flex direction={"column"} grow={1}>
    <Card variation="elevated">
      <Flex direction={"column"} gap={12}>
        <Flex direction={"row"} gap={32} justifyContent="flex-start">
          <Heading level={5} children={`Food Journal`} />
          <Button
            variation="primary"
            size="small"
            onClick={() => {
              navigate("/user/quick-actions/insights/food-journal/add");
            }}
          >
            Add
          </Button>
        </Flex>
        <Divider />
        {data?.id != null && (
          <Flex direction={"column"} gap={12}>
            <Heading level={6} children={`Most Recent Food Log`} />
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Date: {data.logDate}
            </Text>
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Breakfast: {data.breakfastEatDrink}
            </Text>
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Lunch: {data.lunchEatDrink}
            </Text>
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Dinner: {data.dinnerEatDrink}
            </Text>
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Snacks: {data.snacksEatDrink}
            </Text>
            <Text as="span" fontSize="12px" style={{ marginLeft: "12px" }}>
              Water: {data.waterConsumption}
            </Text>
            <Flex direction={"row"} gap={12} justifyContent="flex-end">
              <Button
                size="small"
                variation="link"
                style={{ paddingRight: "4px", paddingLeft: "4px" }}
                onClick={() => {
                  navigate(
                    `/user/quick-actions/insights/food-journal/${data.id}/edit`
                  );
                }}
              >
                <RiPencilFill />
              </Button>
              <Button
                size="small"
                variation="link"
                style={{ paddingRight: "4px", paddingLeft: "4px" }}
                onClick={async () => {
                  deleteFoodJournal.mutateAsync(data.id);
                }}
              >
                <FiTrash />
              </Button>
            </Flex>
          </Flex>
        )}
        {data?.id == null && (
          <Flex direction={"column"} gap={12}>
            <Text children={`No food log registered`} />
          </Flex>
        )}
      </Flex>
    </Card>
    </Flex>

  );
}
